import Image from 'next/image'
import type { ILandingRouteContentLogo } from '@/features/landing-page/helpers/landing-route-content'

interface IOnboardingSectionLogoBarProps {
    logos: ILandingRouteContentLogo[]
    label?: string
}

export function OnboardingSectionLogoBar({ logos, label = 'Trusted by' }: IOnboardingSectionLogoBarProps) {
    return (
        <div className="flex flex-col items-center gap-3 md:gap-4">
            <div
                className="text-[11px] md:text-[12px] font-medium uppercase text-black/50 text-center"
                style={{ lineHeight: '14px', letterSpacing: '1.2px' }}
            >
                {label}
            </div>
            <div className="flex items-center justify-center gap-5 md:gap-10">
                {logos.map((logo) => (
                    <div key={logo.name} className="flex h-5 md:h-6 items-center justify-center gap-1.5">
                        <Image
                            src={logo.src}
                            alt={logo.alt}
                            width={100}
                            height={24}
                            className="h-full w-auto object-contain"
                        />
                        {logo.showName && (
                            <span className="text-[13px] md:text-[14px] font-semibold text-[#161514] tracking-[-0.2px]">{logo.name}</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
